/* ============================================================
   taps-header-kinetic.js — Kinetic HUD navbar behavior.
   Island condense on scroll, full-logo -> mark swap (CSS-driven
   via .thk-isl), sliding pill indicator, energy-line scroll fill
   (no readout), magnetic buttons, Enrol glow ring, burger panel,
   gated load intro. Guarded: works (statically) without gsap.
   ============================================================ */
(function(){
  function init(){
    var root = document.querySelector('.taps-header.thk');
    if(!root || root.__thk) return;
    root.__thk = true;
    var g = window.gsap;
    var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animate = !!g && !reduced;
    var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

    /* ----- island condense ----- */
    var condensed = null;
    function condense(){
      var on = (window.scrollY || window.pageYOffset || 0) > 40;
      if(on !== condensed){
        condensed = on;
        root.classList.toggle('thk-isl', on);
        setTimeout(placePill, 520); /* re-seat after shell morph */
      }
    }

    /* ----- energy line fill (scroll progress, no readout) ----- */
    var fill = root.querySelector('.thk-line-fill');
    function progress(){
      var doc = document.documentElement;
      var max = Math.max(doc.scrollHeight - window.innerHeight, 1);
      var p = Math.min(Math.max((window.scrollY || 0) / max, 0), 1);
      if(fill) fill.style.transform = 'scaleX(' + p + ')';
    }
    window.addEventListener('scroll', function(){ condense(); progress(); }, { passive:true });
    window.addEventListener('resize', progress);
    condense(); progress();

    /* ----- sliding pill indicator ----- */
    var nav = root.querySelector('.thk-nav');
    var pill = root.querySelector('.thk-pill');
    var links = nav ? Array.prototype.slice.call(nav.querySelectorAll('.thk-link')) : [];
    var current = nav ? (nav.querySelector('.thk-link.thk-active') || null) : null;
    function seat(el, spring){
      if(!pill || !nav) return;
      if(!el){ pill.style.opacity = '0'; return; }
      var nb = nav.getBoundingClientRect();
      var lb = el.getBoundingClientRect();
      var x = lb.left - nb.left;
      if(animate && spring){
        g.to(pill, { x:x, width:lb.width, opacity:1, duration:.5, ease:'back.out(1.7)', overwrite:'auto' });
      } else if(g){
        g.set(pill, { x:x, width:lb.width, opacity:1 });
      } else {
        pill.style.transform = 'translateX(' + x + 'px)';
        pill.style.width = lb.width + 'px';
        pill.style.opacity = '1';
      }
    }
    function placePill(){ seat(current, false); }
    links.forEach(function(l){
      l.addEventListener('mouseenter', function(){ seat(l, true); });
      l.addEventListener('focus', function(){ seat(l, true); });
    });
    if(nav){
      nav.addEventListener('mouseleave', function(){ seat(current, true); });
      nav.addEventListener('focusout', function(e){ if(!nav.contains(e.relatedTarget)) seat(current, true); });
    }
    window.addEventListener('resize', placePill);

    /* ----- magnetic buttons ----- */
    function magnet(el, pull){
      if(!el || !animate || !fine) return;
      var qx = g.quickTo(el, 'x', { duration:.35, ease:'power3.out' });
      var qy = g.quickTo(el, 'y', { duration:.35, ease:'power3.out' });
      el.addEventListener('mousemove', function(e){
        var b = el.getBoundingClientRect();
        qx((e.clientX - (b.left + b.width/2)) * pull);
        qy((e.clientY - (b.top + b.height/2)) * pull);
      });
      el.addEventListener('mouseleave', function(){
        g.to(el, { x:0, y:0, duration:.7, ease:'elastic.out(1,.5)' });
      });
    }
    magnet(root.querySelector('.thk-enrol'), .16);
    // same pull ratio as the PDP hero Enroll CTA ([data-h3-magnetic]) so the
    // cart pill it morphs into carries the identical cursor-follow feel
    magnet(root.querySelector('.thk-cart'), .28);

    /* ----- burger / mobile panel ----- */
    var burger = root.querySelector('.thk-burger');
    var panel = root.querySelector('.thk-panel');
    if(burger && panel){
      burger.addEventListener('click', function(){
        var open = root.classList.toggle('thk-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if(open && animate){
          g.from(panel.querySelectorAll('.thk-panel-link, .thk-panel-cta > *'),
            { y:14, opacity:0, duration:.45, stagger:.05, ease:'back.out(1.7)', clearProps:'all' });
        }
      });
    }

    /* ----- load intro (elements pre-hidden by .thk-js gate) ----- */
    var anims = root.querySelectorAll('.thk-anim');
    if(animate){
      var tl = g.timeline({ defaults:{ ease:'power4.out' } });
      tl.to(root.querySelector('.thk-logo'), { opacity:1, duration:.01 }, 0);
      tl.fromTo(root.querySelector('.thk-logo-full'), { y:10, opacity:0 }, { y:0, opacity:1, duration:.6, ease:'back.out(1.5)' }, .1);
      if(links.length) tl.fromTo(links, { y:14, opacity:0 }, { y:0, opacity:1, duration:.5, stagger:.06, ease:'back.out(1.7)', clearProps:'transform' }, .3);
      tl.fromTo(root.querySelectorAll('.thk-actions > *'), { y:10, opacity:0 }, { y:0, opacity:1, duration:.45, stagger:.07, ease:'back.out(1.7)', clearProps:'transform' }, .5);
      tl.add(function(){
        anims.forEach(function(el){ el.style.opacity = ''; });
        root.classList.remove('thk-js');
        placePill();
      }, .95);
      var spark = root.querySelector('.thk-line-spark');
      if(spark) g.fromTo(spark, { left:'-5%', opacity:1 }, { left:'102%', opacity:0, duration:1.2, ease:'power4.out', delay:.7 });
    } else {
      root.classList.remove('thk-js');
      placePill();
    }
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* ============================================================
   Cart-aware CTA — keeps the Enroll pill / cart icon in sync.
   The state is server-rendered by taps-header.liquid, so this is
   purely a re-sync layer for the cases Liquid can't see:
     - browser Back from checkout restoring a bfcache page
     - the cart page emptying itself via fetch (taps:cart:update)
   Independent of the main HUD init so a gsap failure can't break it.
   ============================================================ */
(function(){
  var groups = document.querySelectorAll('[data-thk-actions]');
  if(!groups.length) return;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
  var SEEN = 'taps:cart:seen';

  function label(n){
    return n === 1
      ? 'Cart: 1 seat — review and finish checkout'
      : 'Cart: ' + n + ' seats — review and finish checkout';
  }

  function collapse(el, hidden){
    if(!el) return;
    clearTimeout(el.__thkT);
    if(hidden){ el.__thkT = setTimeout(function(){ el.classList.add('thk-collapsed'); }, 520); }
    else { el.classList.remove('thk-collapsed'); }
  }

  function hideFromAT(el, hidden){
    if(!el) return;
    if(hidden){ el.setAttribute('tabindex','-1'); el.setAttribute('aria-hidden','true'); }
    else { el.removeAttribute('tabindex'); el.removeAttribute('aria-hidden'); }
  }

  function apply(count, animate){
    for(var i=0;i<groups.length;i++){
      var g = groups[i];
      var had = g.classList.contains('thk-has-cart');
      g.classList.toggle('thk-has-cart', count > 0);

      var n = g.querySelector('[data-thk-cart-n]');
      if(n && n.textContent !== String(count)){
        n.textContent = count;
        if(animate && !reduce && count > 0){
          n.classList.add('thk-pop');
          setTimeout(function(el){ return function(){ el.classList.remove('thk-pop'); }; }(n), 340);
        }
      }

      var link = g.querySelector('[data-thk-cart]');
      if(link && link.hasAttribute('aria-label')) link.setAttribute('aria-label', label(count));

      // the magnet leaves an inline transform behind — reset it as the pill collapses
      if(link && count === 0) link.style.transform = '';

      // .thk-collapsed hard-hides the inactive CTA (see the critical <style> in
      // taps-header.liquid). Reveal instantly; hide only after the morph has run,
      // so the collapse still animates instead of snapping.
      collapse(link, count === 0);
      collapse(g.querySelector('[data-thk-enrol]'), count > 0);

      // keep the collapsed CTA out of the tab order (it is invisible but present)
      var pillEl = g.querySelector('[data-thk-enrol]');
      hideFromAT(link, count === 0);
      hideFromAT(pillEl, count > 0);

      // morphing back into the Enroll pill is a state change worth feeling
      if(had && count === 0 && !reduce){
        var pill = g.querySelector('[data-thk-enrol]');
        if(pill){
          pill.style.transition = 'none';
          requestAnimationFrame(function(p){ return function(){ p.style.transition = ''; }; }(pill));
        }
      }
    }
  }

  /* one-time arrival pulse: only the first time this count is seen */
  function pulse(count){
    if(reduce || !count) return;
    var seen;
    try { seen = sessionStorage.getItem(SEEN); } catch(e){ seen = null; }
    if(seen === String(count)) return;
    try { sessionStorage.setItem(SEEN, String(count)); } catch(e){}

    for(var i=0;i<groups.length;i++){
      var link = groups[i].querySelector('.thk-cart');
      if(!link) continue;
      link.classList.add('thk-arrive');
      setTimeout(function(el){ return function(){ el.classList.remove('thk-arrive'); }; }(link), 2500);
    }
  }

  function sync(animate){
    fetch('/cart.js', { headers:{ Accept:'application/json' }, credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cart){
        if(!cart) return;
        apply(cart.item_count, animate);
        pulse(cart.item_count);
      })
      .catch(function(){ /* server-rendered state stands */ });
  }

  // the cart page tells us directly — no round trip
  document.addEventListener('taps:cart:update', function(e){
    apply((e.detail && e.detail.count) || 0, true);
  });

  // Back from checkout: bfcache restores stale markup — re-sync.
  window.addEventListener('pageshow', function(e){ if(e.persisted) sync(true); });

  // First paint: honour the server state, just play the arrival pulse.
  var initial = document.querySelector('[data-thk-cart-n]');
  pulse(initial ? parseInt(initial.textContent, 10) || 0 : 0);
})();
